export default __webpack_public_path__ + "static/apercu-bold-f60fb1035f147d90d695f183f3587431.woff2";